// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   Create Tickets — Premium UI
   ═══════════════════════════════════════════════════════════ */

.agce-ctickets {
  width: 100%;
  max-width: 100%;
}

/* ── Header ──────────────────────────────────────────────── */
.agce-ctickets__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 32px;
  padding: 28px 32px;
  border-radius: 16px;
  background: #303137;
  border: 1px solid #e2e8f00d;
  position: relative;
  overflow: hidden;
}

body.light_theme .agce-ctickets__header {
  background: linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%);
  border: 1px solid #e2e8f0;
}

.agce-ctickets__header::after {
  content: "";
  position: absolute;
  right: -30px;
  bottom: -30px;
  width: 140px;
  height: 140px;
  background: radial-gradient(circle, rgba(48, 50, 54, 0.04) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.agce-ctickets__header-left {
  flex: 1 1;
  min-width: 0;
}

.agce-ctickets__header-icon {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: #303236;
  color: #fff;
  font-size: 26px;
  box-shadow: 0 4px 14px rgba(48, 50, 54, 0.18);
}

/* ── Breadcrumb ──────────────────────────────────────────── */
.agce-ctickets__breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  margin-bottom: 12px;
}

.agce-ctickets__breadcrumb-link {
  color: #d3d3d3;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  transition: color 0.15s ease;
}

body.light_theme .agce-ctickets__breadcrumb-link {
  color: #6d6d6d;
}

.agce-ctickets__breadcrumb-link:hover {
  text-decoration: underline;
  color: #fff;
}

body.light_theme .agce-ctickets__breadcrumb-link:hover {
  color: #0f172a;
}

.agce-ctickets__breadcrumb-sep {
  color: #cbd5e1;
  font-size: 12px;
}

.agce-ctickets__breadcrumb-current {
  color: #f7f7f7;
  font-weight: 600;
}

body.light_theme .agce-ctickets__breadcrumb-current {
  color: #0f172a;
}

/* ── Titles ──────────────────────────────────────────────── */
.agce-ctickets__title {
  font-size: 24px;
  font-weight: 700;
  color: #f5f5f5;
  margin: 0 0 6px;
  letter-spacing: -0.01em;
}

body.light_theme .agce-ctickets__title {
  color: #0f172a;
}

p.agce-ctickets__sub {
  font-size: 14px;
  color: #e9e9e9;
  margin: 0;
  line-height: 1.5;
}

body.light_theme p.agce-ctickets__sub {
  color: #64748b;
}

/* ── Form Grid ───────────────────────────────────────────── */
.agce-ctickets__form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.agce-ctickets__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.agce-ctickets__field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.agce-ctickets__field--full {
  width: 100%;
}

/* ── Labels ──────────────────────────────────────────────── */
.agce-ctickets__label {
  font-size: 14px;
  font-weight: 600;
  color: #eeeeee;
  display: flex;
  align-items: center;
  gap: 6px;
  -webkit-user-select: none;
          user-select: none;
}

body.light_theme .agce-ctickets__label {
  color: #1e293b;
}

.agce-ctickets__label-icon {
  font-size: 16px;
  color: #ebebeb;
}

body.light_theme .agce-ctickets__label-icon {
  color: #64748b;
}

.agce-ctickets__required {
  color: #ef4444;
  font-size: 13px;
}

.agce-ctickets__optional {
  color: #94a3b8;
  font-size: 12px;
  font-weight: 400;
}

/* ── Inputs & Selects ────────────────────────────────────── */
.agce-ctickets__input,
.agce-ctickets__select,
.agce-ctickets__textarea {
  width: 100%;
  border: 1.5px solid #e2e8f00f;
  border-radius: 10px;
  background: #ffffff1a;
  color: #efefef;
  font-size: 14px;
  padding: 12px 14px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  color-scheme: dark;
}

.agce-ctickets__select option {
  background: #1e2026;
  color: #efefef;
}

body.light_theme .agce-ctickets__input,
body.light_theme .agce-ctickets__select,
body.light_theme .agce-ctickets__textarea {
  border: 1.5px solid #e2e8f0;
  background: #fff;
  color: #0f172a;
  color-scheme: light;
}

body.light_theme .agce-ctickets__select option {
  background: #ffffff;
  color: #0f172a;
}

.agce-ctickets__input::placeholder,
.agce-ctickets__textarea::placeholder {
  color: #94a3b8;
}

.agce-ctickets__input:focus,
.agce-ctickets__select:focus,
.agce-ctickets__textarea:focus {
  border-color: #303236;
  box-shadow: 0 0 0 3px rgba(48, 50, 54, 0.08);
}

.agce-ctickets__input:disabled,
.agce-ctickets__select:disabled,
.agce-ctickets__textarea:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* ── Custom select wrapper ───────────────────────────────── */
.agce-ctickets__select-wrap {
  position: relative;
}

/* ── Custom Dropdown ─────────────────────────────────────── */
.agce-custom-dropdown {
  position: relative;
  width: 100%;
}

.agce-custom-dropdown.disabled {
  opacity: 0.55;
  pointer-events: none;
}

.agce-custom-dropdown__header {
  width: 100%;
  border: 1.5px solid #e2e8f00f;
  border-radius: 10px;
  background: #ffffff1a;
  color: #efefef;
  font-size: 14px;
  padding: 12px 14px;
  padding-right: 36px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
}

body.light_theme .agce-custom-dropdown__header {
  border: 1.5px solid #e2e8f0;
  background: #fff;
  color: #0f172a;
}

.agce-custom-dropdown__header.open {
  border-color: #303236;
  box-shadow: 0 0 0 3px rgba(48, 50, 54, 0.08);
}

.agce-custom-dropdown__header .placeholder {
  color: #efefef;
  background-color: transparent;
}

body.light_theme .agce-custom-dropdown__header .placeholder {
  color: #1c1c1c;
}

.agce-custom-dropdown__arrow {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #64748b;
  pointer-events: none;
  transition: transform 0.2s ease;
}

.agce-custom-dropdown__arrow.open {
  transform: translateY(-50%) rotate(180deg);
}

.agce-custom-dropdown__list {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 100%;
  max-height: 250px;
  overflow-y: auto;
  background: #1e2026;
  border: 1px solid #303236;
  border-radius: 10px;
  padding: 8px 0;
  margin: 0;
  list-style: none;
  z-index: 100;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
  animation: dropdownFadeIn 0.2s ease;
}

body.light_theme .agce-custom-dropdown__list {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.agce-custom-dropdown__item {
  padding: 10px 16px;
  font-size: 14px;
  color: #efefef;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

body.light_theme .agce-custom-dropdown__item {
  color: #0f172a;
}

.agce-custom-dropdown__item:hover {
  background-color: #2b2e36;
}

body.light_theme .agce-custom-dropdown__item:hover {
  background-color: #f1f5f9;
}

.agce-custom-dropdown__item.selected {
  color: #d1aa67;
  font-weight: 600;
  background-color: rgba(209, 170, 103, 0.1);
}

body.light_theme .agce-custom-dropdown__item.selected {
  background-color: rgba(209, 170, 103, 0.05);
}

.agce-custom-dropdown__item .check-icon {
  font-size: 16px;
  color: #d1aa67;
}

/* ── Textarea ────────────────────────────────────────────── */
.agce-ctickets__textarea-wrap {
  position: relative;
}

.agce-ctickets__textarea {
  min-height: 180px;
  resize: vertical;
  padding-bottom: 32px;
}

.agce-ctickets__char-count {
  position: absolute;
  bottom: 10px;
  right: 14px;
  font-size: 12px;
  color: #94a3b8;
  pointer-events: none;
  transition: color 0.15s ease;
}

.agce-ctickets__char-count--warn {
  color: #f59e0b;
}

/* ── Dropzone (File Upload) ──────────────────────────────── */
.agce-ctickets__dropzone {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 14px;
  border: 1.5px dashed #d1d5db14;
  border-radius: 10px;
  background: #ffffff1a;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.15s ease;
  outline: none;
}

body.light_theme .agce-ctickets__dropzone {
  border: 1.5px dashed #d1d5db;
  background: #fff;
}

.agce-ctickets__dropzone:hover {
  border-color: #303236;
}

.agce-ctickets__dropzone:focus-visible {
  border-color: #303236;
  box-shadow: 0 0 0 3px rgba(48, 50, 54, 0.08);
}

.agce-ctickets__dropzone--active {
  border-color: #303236;
  background: #e8ecf0;
  transform: scale(1.01);
}

.agce-ctickets__dropzone-icon {
  font-size: 20px;
  color: #64748b;
  display: flex;
  align-items: center;
}

.agce-ctickets__dropzone-text {
  font-size: 14px;
  color: #a3a3a3;
  text-align: center;
}

body.light_theme .agce-ctickets__dropzone-text {
  color: #475569;
}

.agce-ctickets__dropzone-text strong {
  color: #e9e9e9;
  text-decoration: underline;
  text-underline-offset: 2px;
}

body.light_theme .agce-ctickets__dropzone-text strong {
  color: #303236;
}

.agce-ctickets__dropzone-hint {
  display: none;
}

/* ── Attached file chip ──────────────────────────────────── */
.agce-ctickets__file-attached {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
}

.agce-ctickets__file-info {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.agce-ctickets__file-icon {
  font-size: 22px;
  color: #303236;
  flex-shrink: 0;
}

.agce-ctickets__file-meta {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.agce-ctickets__file-name {
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agce-ctickets__file-size {
  font-size: 11px;
  color: #94a3b8;
}

.agce-ctickets__file-remove {
  flex-shrink: 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
  color: #94a3b8;
  padding: 2px;
  border-radius: 50%;
  transition: color 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.agce-ctickets__file-remove:hover {
  color: #ef4444;
}

/* ── Actions (Buttons) ───────────────────────────────────── */
.agce-ctickets__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 8px;
  border-top: 1px solid #585858;
  margin-top: 4px;
}

body.light_theme .agce-ctickets__actions {
  border-top: 1px solid #f1f5f9;
}

.agce-ctickets__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 44px;
  padding: 0 28px;
  border-radius: 10px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.agce-ctickets__btn--cancel {
  background: #f1f5f9;
  color: #475569;
  border: 1.5px solid #e2e8f0;
}

.agce-ctickets__btn--cancel:hover {
  background: #e2e8f0;
  color: #1e293b;
}

.agce-ctickets__btn--submit {
  background: #303236;
  color: #fff;
  box-shadow: 0 2px 8px rgba(48, 50, 54, 0.15);
}

.agce-ctickets__btn--submit:hover:not(:disabled) {
  background: #1e2024;
  box-shadow: 0 4px 16px rgba(48, 50, 54, 0.22);
  transform: translateY(-1px);
}

.agce-ctickets__btn--submit:active:not(:disabled) {
  transform: translateY(0);
}

.agce-ctickets__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none !important;
}

/* ── Spinner ─────────────────────────────────────────────── */
@keyframes agce-ctickets-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.agce-ctickets__spin {
  display: inline-block;
  animation: agce-ctickets-spin 0.8s linear infinite;
}

/* ═══════════════════════════════════════════════════════════
   Responsive
   ═══════════════════════════════════════════════════════════ */
@media (max-width: 991.98px) {
  .agce-ctickets__header {
    padding: 22px 20px;
    border-radius: 12px;
  }

  .agce-ctickets__header-icon {
    width: 46px;
    height: 46px;
    font-size: 22px;
    border-radius: 12px;
  }

  .agce-ctickets__title {
    font-size: 20px;
  }

  .agce-ctickets__row {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .agce-ctickets__textarea {
    min-height: 160px;
  }

  .agce-ctickets__actions {
    flex-direction: column-reverse;
    gap: 10px;
  }

  .agce-ctickets__btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 767px) {
  .agce-ctickets__header {
    padding: 18px 16px;
    margin-bottom: 24px;
    flex-direction: column;
    gap: 16px;
  }

  .agce-ctickets__header-icon {
    align-self: flex-start;
    width: 40px;
    height: 40px;
    font-size: 20px;
    border-radius: 10px;
  }

  .agce-ctickets__title {
    font-size: 18px;
  }

  .agce-ctickets__form {
    gap: 18px;
  }

  .agce-ctickets__row {
    gap: 18px;
  }

  .agce-ctickets__textarea {
    min-height: 120px;
  }

  .agce-ctickets__dropzone {
    padding: 18px 12px;
  }

  .agce-ctickets__btn {
    height: 42px;
    font-size: 13px;
    padding: 0 20px;
    border-radius: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/CreateTicketsPage/createTickets.css"],"names":[],"mappings":"AAAA;;gEAEgE;;AAEhE;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,+EAA+E;EAC/E,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,6CAA6C;AAC/C;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;;;EAGE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,oFAAoF;EACpF,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,oFAAoF;EACpF,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yDAAyD;EACzD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,oFAAoF;EACpF,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,+DAA+D;AAC/D;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;;gEAEgE;AAChE;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════════\n   Create Tickets — Premium UI\n   ═══════════════════════════════════════════════════════════ */\n\n.agce-ctickets {\n  width: 100%;\n  max-width: 100%;\n}\n\n/* ── Header ──────────────────────────────────────────────── */\n.agce-ctickets__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 32px;\n  padding: 28px 32px;\n  border-radius: 16px;\n  background: #303137;\n  border: 1px solid #e2e8f00d;\n  position: relative;\n  overflow: hidden;\n}\n\nbody.light_theme .agce-ctickets__header {\n  background: linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%);\n  border: 1px solid #e2e8f0;\n}\n\n.agce-ctickets__header::after {\n  content: \"\";\n  position: absolute;\n  right: -30px;\n  bottom: -30px;\n  width: 140px;\n  height: 140px;\n  background: radial-gradient(circle, rgba(48, 50, 54, 0.04) 0%, transparent 70%);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.agce-ctickets__header-left {\n  flex: 1;\n  min-width: 0;\n}\n\n.agce-ctickets__header-icon {\n  flex-shrink: 0;\n  width: 56px;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 14px;\n  background: #303236;\n  color: #fff;\n  font-size: 26px;\n  box-shadow: 0 4px 14px rgba(48, 50, 54, 0.18);\n}\n\n/* ── Breadcrumb ──────────────────────────────────────────── */\n.agce-ctickets__breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  margin-bottom: 12px;\n}\n\n.agce-ctickets__breadcrumb-link {\n  color: #d3d3d3;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  transition: color 0.15s ease;\n}\n\nbody.light_theme .agce-ctickets__breadcrumb-link {\n  color: #6d6d6d;\n}\n\n.agce-ctickets__breadcrumb-link:hover {\n  text-decoration: underline;\n  color: #fff;\n}\n\nbody.light_theme .agce-ctickets__breadcrumb-link:hover {\n  color: #0f172a;\n}\n\n.agce-ctickets__breadcrumb-sep {\n  color: #cbd5e1;\n  font-size: 12px;\n}\n\n.agce-ctickets__breadcrumb-current {\n  color: #f7f7f7;\n  font-weight: 600;\n}\n\nbody.light_theme .agce-ctickets__breadcrumb-current {\n  color: #0f172a;\n}\n\n/* ── Titles ──────────────────────────────────────────────── */\n.agce-ctickets__title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #f5f5f5;\n  margin: 0 0 6px;\n  letter-spacing: -0.01em;\n}\n\nbody.light_theme .agce-ctickets__title {\n  color: #0f172a;\n}\n\np.agce-ctickets__sub {\n  font-size: 14px;\n  color: #e9e9e9;\n  margin: 0;\n  line-height: 1.5;\n}\n\nbody.light_theme p.agce-ctickets__sub {\n  color: #64748b;\n}\n\n/* ── Form Grid ───────────────────────────────────────────── */\n.agce-ctickets__form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.agce-ctickets__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n.agce-ctickets__field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.agce-ctickets__field--full {\n  width: 100%;\n}\n\n/* ── Labels ──────────────────────────────────────────────── */\n.agce-ctickets__label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #eeeeee;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  user-select: none;\n}\n\nbody.light_theme .agce-ctickets__label {\n  color: #1e293b;\n}\n\n.agce-ctickets__label-icon {\n  font-size: 16px;\n  color: #ebebeb;\n}\n\nbody.light_theme .agce-ctickets__label-icon {\n  color: #64748b;\n}\n\n.agce-ctickets__required {\n  color: #ef4444;\n  font-size: 13px;\n}\n\n.agce-ctickets__optional {\n  color: #94a3b8;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n/* ── Inputs & Selects ────────────────────────────────────── */\n.agce-ctickets__input,\n.agce-ctickets__select,\n.agce-ctickets__textarea {\n  width: 100%;\n  border: 1.5px solid #e2e8f00f;\n  border-radius: 10px;\n  background: #ffffff1a;\n  color: #efefef;\n  font-size: 14px;\n  padding: 12px 14px;\n  outline: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n  color-scheme: dark;\n}\n\n.agce-ctickets__select option {\n  background: #1e2026;\n  color: #efefef;\n}\n\nbody.light_theme .agce-ctickets__input,\nbody.light_theme .agce-ctickets__select,\nbody.light_theme .agce-ctickets__textarea {\n  border: 1.5px solid #e2e8f0;\n  background: #fff;\n  color: #0f172a;\n  color-scheme: light;\n}\n\nbody.light_theme .agce-ctickets__select option {\n  background: #ffffff;\n  color: #0f172a;\n}\n\n.agce-ctickets__input::placeholder,\n.agce-ctickets__textarea::placeholder {\n  color: #94a3b8;\n}\n\n.agce-ctickets__input:focus,\n.agce-ctickets__select:focus,\n.agce-ctickets__textarea:focus {\n  border-color: #303236;\n  box-shadow: 0 0 0 3px rgba(48, 50, 54, 0.08);\n}\n\n.agce-ctickets__input:disabled,\n.agce-ctickets__select:disabled,\n.agce-ctickets__textarea:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* ── Custom select wrapper ───────────────────────────────── */\n.agce-ctickets__select-wrap {\n  position: relative;\n}\n\n/* ── Custom Dropdown ─────────────────────────────────────── */\n.agce-custom-dropdown {\n  position: relative;\n  width: 100%;\n}\n\n.agce-custom-dropdown.disabled {\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n.agce-custom-dropdown__header {\n  width: 100%;\n  border: 1.5px solid #e2e8f00f;\n  border-radius: 10px;\n  background: #ffffff1a;\n  color: #efefef;\n  font-size: 14px;\n  padding: 12px 14px;\n  padding-right: 36px;\n  outline: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  user-select: none;\n}\n\nbody.light_theme .agce-custom-dropdown__header {\n  border: 1.5px solid #e2e8f0;\n  background: #fff;\n  color: #0f172a;\n}\n\n.agce-custom-dropdown__header.open {\n  border-color: #303236;\n  box-shadow: 0 0 0 3px rgba(48, 50, 54, 0.08);\n}\n\n.agce-custom-dropdown__header .placeholder {\n  color: #efefef;\n  background-color: transparent;\n}\n\nbody.light_theme .agce-custom-dropdown__header .placeholder {\n  color: #1c1c1c;\n}\n\n.agce-custom-dropdown__arrow {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 18px;\n  color: #64748b;\n  pointer-events: none;\n  transition: transform 0.2s ease;\n}\n\n.agce-custom-dropdown__arrow.open {\n  transform: translateY(-50%) rotate(180deg);\n}\n\n.agce-custom-dropdown__list {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  width: 100%;\n  max-height: 250px;\n  overflow-y: auto;\n  background: #1e2026;\n  border: 1px solid #303236;\n  border-radius: 10px;\n  padding: 8px 0;\n  margin: 0;\n  list-style: none;\n  z-index: 100;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);\n  animation: dropdownFadeIn 0.2s ease;\n}\n\nbody.light_theme .agce-custom-dropdown__list {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n}\n\n@keyframes dropdownFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.agce-custom-dropdown__item {\n  padding: 10px 16px;\n  font-size: 14px;\n  color: #efefef;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\nbody.light_theme .agce-custom-dropdown__item {\n  color: #0f172a;\n}\n\n.agce-custom-dropdown__item:hover {\n  background-color: #2b2e36;\n}\n\nbody.light_theme .agce-custom-dropdown__item:hover {\n  background-color: #f1f5f9;\n}\n\n.agce-custom-dropdown__item.selected {\n  color: #d1aa67;\n  font-weight: 600;\n  background-color: rgba(209, 170, 103, 0.1);\n}\n\nbody.light_theme .agce-custom-dropdown__item.selected {\n  background-color: rgba(209, 170, 103, 0.05);\n}\n\n.agce-custom-dropdown__item .check-icon {\n  font-size: 16px;\n  color: #d1aa67;\n}\n\n/* ── Textarea ────────────────────────────────────────────── */\n.agce-ctickets__textarea-wrap {\n  position: relative;\n}\n\n.agce-ctickets__textarea {\n  min-height: 180px;\n  resize: vertical;\n  padding-bottom: 32px;\n}\n\n.agce-ctickets__char-count {\n  position: absolute;\n  bottom: 10px;\n  right: 14px;\n  font-size: 12px;\n  color: #94a3b8;\n  pointer-events: none;\n  transition: color 0.15s ease;\n}\n\n.agce-ctickets__char-count--warn {\n  color: #f59e0b;\n}\n\n/* ── Dropzone (File Upload) ──────────────────────────────── */\n.agce-ctickets__dropzone {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 11px 14px;\n  border: 1.5px dashed #d1d5db14;\n  border-radius: 10px;\n  background: #ffffff1a;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.15s ease;\n  outline: none;\n}\n\nbody.light_theme .agce-ctickets__dropzone {\n  border: 1.5px dashed #d1d5db;\n  background: #fff;\n}\n\n.agce-ctickets__dropzone:hover {\n  border-color: #303236;\n}\n\n.agce-ctickets__dropzone:focus-visible {\n  border-color: #303236;\n  box-shadow: 0 0 0 3px rgba(48, 50, 54, 0.08);\n}\n\n.agce-ctickets__dropzone--active {\n  border-color: #303236;\n  background: #e8ecf0;\n  transform: scale(1.01);\n}\n\n.agce-ctickets__dropzone-icon {\n  font-size: 20px;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n}\n\n.agce-ctickets__dropzone-text {\n  font-size: 14px;\n  color: #a3a3a3;\n  text-align: center;\n}\n\nbody.light_theme .agce-ctickets__dropzone-text {\n  color: #475569;\n}\n\n.agce-ctickets__dropzone-text strong {\n  color: #e9e9e9;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\nbody.light_theme .agce-ctickets__dropzone-text strong {\n  color: #303236;\n}\n\n.agce-ctickets__dropzone-hint {\n  display: none;\n}\n\n/* ── Attached file chip ──────────────────────────────────── */\n.agce-ctickets__file-attached {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.agce-ctickets__file-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.agce-ctickets__file-icon {\n  font-size: 22px;\n  color: #303236;\n  flex-shrink: 0;\n}\n\n.agce-ctickets__file-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.agce-ctickets__file-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: #1e293b;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agce-ctickets__file-size {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.agce-ctickets__file-remove {\n  flex-shrink: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 20px;\n  color: #94a3b8;\n  padding: 2px;\n  border-radius: 50%;\n  transition: color 0.15s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.agce-ctickets__file-remove:hover {\n  color: #ef4444;\n}\n\n/* ── Actions (Buttons) ───────────────────────────────────── */\n.agce-ctickets__actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 8px;\n  border-top: 1px solid #585858;\n  margin-top: 4px;\n}\n\nbody.light_theme .agce-ctickets__actions {\n  border-top: 1px solid #f1f5f9;\n}\n\n.agce-ctickets__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 44px;\n  padding: 0 28px;\n  border-radius: 10px;\n  border: none;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.agce-ctickets__btn--cancel {\n  background: #f1f5f9;\n  color: #475569;\n  border: 1.5px solid #e2e8f0;\n}\n\n.agce-ctickets__btn--cancel:hover {\n  background: #e2e8f0;\n  color: #1e293b;\n}\n\n.agce-ctickets__btn--submit {\n  background: #303236;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(48, 50, 54, 0.15);\n}\n\n.agce-ctickets__btn--submit:hover:not(:disabled) {\n  background: #1e2024;\n  box-shadow: 0 4px 16px rgba(48, 50, 54, 0.22);\n  transform: translateY(-1px);\n}\n\n.agce-ctickets__btn--submit:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.agce-ctickets__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n/* ── Spinner ─────────────────────────────────────────────── */\n@keyframes agce-ctickets-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.agce-ctickets__spin {\n  display: inline-block;\n  animation: agce-ctickets-spin 0.8s linear infinite;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Responsive\n   ═══════════════════════════════════════════════════════════ */\n@media (max-width: 991.98px) {\n  .agce-ctickets__header {\n    padding: 22px 20px;\n    border-radius: 12px;\n  }\n\n  .agce-ctickets__header-icon {\n    width: 46px;\n    height: 46px;\n    font-size: 22px;\n    border-radius: 12px;\n  }\n\n  .agce-ctickets__title {\n    font-size: 20px;\n  }\n\n  .agce-ctickets__row {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .agce-ctickets__textarea {\n    min-height: 160px;\n  }\n\n  .agce-ctickets__actions {\n    flex-direction: column-reverse;\n    gap: 10px;\n  }\n\n  .agce-ctickets__btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 767px) {\n  .agce-ctickets__header {\n    padding: 18px 16px;\n    margin-bottom: 24px;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .agce-ctickets__header-icon {\n    align-self: flex-start;\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n    border-radius: 10px;\n  }\n\n  .agce-ctickets__title {\n    font-size: 18px;\n  }\n\n  .agce-ctickets__form {\n    gap: 18px;\n  }\n\n  .agce-ctickets__row {\n    gap: 18px;\n  }\n\n  .agce-ctickets__textarea {\n    min-height: 120px;\n  }\n\n  .agce-ctickets__dropzone {\n    padding: 18px 12px;\n  }\n\n  .agce-ctickets__btn {\n    height: 42px;\n    font-size: 13px;\n    padding: 0 20px;\n    border-radius: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
